var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"white",attrs:{"justify-center":"","row":""}},[_c('div',{staticClass:"text-black-50 mr-auto ml-auto"},[_c('p',[_vm._v("All the believers were together and had everything in common.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }